import { IGetFilterValuesDTO } from '@/models/filters.model';

class GetFilterValuesDTO implements IGetFilterValuesDTO {
  title?: string;
  slug?: string;
  filter_id: string;
  page: number;
  limit: number;

  constructor({
    title_UK,
    title_RU,
    slug,
    filter_id,
    page,
  }: {
    title_UK?: string;
    title_RU?: string;
    slug?: string;
    filter_id: string;
    page: number;
  }) {
    this.title = title_UK ?? title_RU;
    this.slug = slug;
    this.filter_id = filter_id;
    this.page = page ?? 1;
    this.limit = 10;
  }
}

export default GetFilterValuesDTO;
